import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { IPatientDailyReport, PatientDailyReportListRequest } from './patient-daily-report.types';

@Injectable({ providedIn: 'root' })
export class PatientDailyReportService {
  private readonly baseUrl = `${environment.baseURl}/PatientDailyReport`;

  constructor(private http: HttpClient) {}

  create(report: IPatientDailyReport): Observable<BaseRespone<IPatientDailyReport>> {
    return this.http.post<BaseRespone<IPatientDailyReport>>(this.baseUrl, report);
  }

  update(report: IPatientDailyReport): Observable<BaseRespone<IPatientDailyReport>> {
    return this.http.put<BaseRespone<IPatientDailyReport>>(this.baseUrl, report);
  }

  delete(id: number): Observable<BaseRespone<boolean>> {
    return this.http.delete<BaseRespone<boolean>>(`${this.baseUrl}/${id}`);
  }

  getById(id: number): Observable<BaseRespone<IPatientDailyReport>> {
    return this.http.get<BaseRespone<IPatientDailyReport>>(`${this.baseUrl}/${id}`);
  }

  list(request: PatientDailyReportListRequest): Observable<BaseRespone<IPatientDailyReport[]>> {
    return this.http.post<BaseRespone<IPatientDailyReport[]>>(`${this.baseUrl}/List`, request);
  }
}
